import { useEffect, useState } from 'react';
import { WhatsAppApi } from '../../api/resources';

/**
 * Pick an approved template and fill its variables / optional header image.
 * Controlled via `value` = { templateId, vars, headerFile }.
 */
export default function TemplateFields({ templates, value, onChange, errors = {} }) {
  const selected = templates.find((t) => t.id === Number(value.templateId));
  const [defaultImg, setDefaultImg] = useState(null);

  useEffect(() => {
    setDefaultImg(null);
    if (!selected?.has_header_image) return undefined;
    let url;
    let dead = false;
    WhatsAppApi.templateImageBlob(selected.id)
      .then((b) => {
        if (dead) return;
        url = URL.createObjectURL(b);
        setDefaultImg(url);
      })
      .catch(() => {});
    return () => {
      dead = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [selected?.id, selected?.has_header_image]);

  const set = (patch) => onChange({ ...value, ...patch });
  const preview = selected
    ? selected.body.replace(/\{\{(\d+)\}\}/g, (m, n) => value.vars[n - 1] || m)
    : '';

  return (
    <>
      <div className="field">
        <label>Template *</label>
        <select
          value={value.templateId}
          onChange={(e) => set({ templateId: e.target.value, vars: [], headerFile: null })}
        >
          <option value="">Select an approved template…</option>
          {templates.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name} ({t.language})
            </option>
          ))}
        </select>
        {errors.template_id && <div className="err">{errors.template_id}</div>}
      </div>

      {selected && (
        <>
          {Array.from({ length: selected.variable_count }, (_, i) => (
            <div className="field" key={i}>
              <label>
                Variable {`{{${i + 1}}}`}
                {selected.body_examples?.[i] ? ` · e.g. ${selected.body_examples[i]}` : ''}
              </label>
              <input
                type="text"
                value={value.vars[i] || ''}
                onChange={(e) => {
                  const vars = [...value.vars];
                  vars[i] = e.target.value;
                  set({ vars });
                }}
              />
            </div>
          ))}
          {errors.variables && <div className="err">{errors.variables}</div>}

          {selected.header_format === 'IMAGE' && (
            <div className="field">
              <label>Header image {selected.has_header_image ? '(optional override)' : '*'}</label>
              {defaultImg && !value.headerFile && <img className="wa-thumb" src={defaultImg} alt="" />}
              <input
                type="file"
                accept="image/jpeg,image/png"
                onChange={(e) => set({ headerFile: e.target.files[0] || null })}
              />
              {errors.header_image && <div className="err">{errors.header_image}</div>}
            </div>
          )}

          <div className="wa-preview">
            {selected.header_text && <strong>{selected.header_text}</strong>}
            <p>{preview}</p>
            {selected.footer_text && <small>{selected.footer_text}</small>}
          </div>
        </>
      )}
    </>
  );
}

export const emptyTemplateValue = { templateId: '', vars: [], headerFile: null };
